import { cssClass } from '@/shared/utils'
import { recommendationInfoContainerSize } from 'containers/profile/styles/recommendations.css'
import { motion } from 'framer-motion'

interface RecommendationCardBaseProps {
  children: React.ReactNode
  avatar: React.ReactNode
  animationKey?: string
}

export const RecommendationCardBase = ({
  children,
  avatar,
  animationKey = 'recommendation_card_base',
}: RecommendationCardBaseProps) => {
  return (
    <motion.div
      key={animationKey}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      className="full-w bg-white-primary rounded-16 p-16 flex gap-16"
    >
      <div>{avatar}</div>
      <div className={cssClass([recommendationInfoContainerSize])}>
        {children}
      </div>
    </motion.div>
  )
}
